'use strict';

var _setup = require('./setup.js');

var hoverOffDelay = 300;

var $navOuter = $('.nx-header--nav');
var $holder = $('#nx-menu-dropdowns-height');
var $menuEdge = $('#nx-menu-dropdownedge');

//dropdown items to stagger in
var $imgpair = _setup.s.$menuDropdowns.find('.nx-imgpair--item');
var $imgStreak = _setup.s.$menuDropdowns.find('.nx-imgpair--streak');
var $menuListitems = _setup.s.$menuDropdowns.find('.nx--imglink-list > li');
var $storeLinks = _setup.s.$menuDropdowns.find('.nx-headerdrop--storelinks');
var $featuredGrill = _setup.s.$menuDropdowns.find('.nx-headerdrop--grillfeature');

var $prevSection = null;
var prevSectionName = null;
var currentSectionName = null;

//motion state
// _s.menuDropdownShowing
var isOpening = false;
var isTriggeredOpen = false;

//imgs been lazy loaded?
var navImagesLoaded = {
	products: false,
	explore: false
};

var setTriggeredOpen = function setTriggeredOpen() {
	return isTriggeredOpen = true;
};
var setCompletedOpen = function setCompletedOpen() {
	return _setup._s.menuDropdownShowing = true;
};

function hoverOn($section, name) {
	isOpening = true;
	if (!_setup._s.menuDropdownShowing) {
		_setup.s.$body.addClass('is-showing-menudropdown');
		_setup._s.menuDropdownShowing = true;
		TweenMax.to(_setup.s.$menuDropdownsBg, 0.35, { autoAlpha: 1, delay: 0 });
		TweenMax.fromTo(_setup.s.$menuDropdowns, 0.5, { autoAlpha: 0, y: '-100%' }, { y: '0%', autoAlpha: 1, ease: Expo.easeOut });
	}
	if ($prevSection) {
		TweenMax.to($prevSection, 0.15, { autoAlpha: 0 });
		_setup.s.$body.removeClass('is-menudropdown-' + prevSectionName);
	}
	if (name) {
		currentSectionName = name;
		_setup.s.$body.addClass('is-menudropdown-' + currentSectionName);

		if (name === 'products' && prevSectionName !== 'products') {

			TweenMax.staggerFromTo($imgpair, 0.9, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: 0.2, ease: Expo.easeOut }, 0.15);
			TweenMax.fromTo($imgStreak, 0.9, { scaleY: 0 }, { scaleY: 1, delay: 0.275, ease: Expo.easeOut });
			TweenMax.fromTo($storeLinks, 0.9, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, delay: 0.35, ease: Expo.easeOut });
			TweenMax.fromTo($featuredGrill, 0.9, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, delay: 0.4, ease: Expo.easeOut });
		} else if (name === 'explore' && prevSectionName !== 'explore') {

			TweenMax.staggerFromTo($menuListitems, 0.9, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: 0.2, ease: Expo.easeOut }, 0.1);
		}

		var scaleVal = name === 'products' ? 0.9 : 0.75;
		TweenMax.to($menuEdge, 0.35, { scaleX: scaleVal, ease: Expo.easeOut });
	}
	TweenMax.to($holder, 0.2, { height: $section.outerHeight() + 'px', ease: Power3.easeOut });
	TweenMax.to($section, 0.45, { autoAlpha: 1, onComplete: function onComplete() {
			return isOpening = false;
		} });

	$prevSection = $section;
	prevSectionName = currentSectionName;
};

function closeMenuOverlay() {
	if (!_setup._s.menuDropdownShowing) return;

	isTriggeredOpen = false;
	setTimeout(function () {
		if (!isTriggeredOpen) {
			_setup.s.$body.removeClass('is-showing-menudropdown is-menudropdown-' + prevSectionName);
			TweenMax.to(_setup.s.$menuDropdowns, 0.2, { autoAlpha: 0, y: '-100%', onComplete: function onComplete() {
					return _setup._s.menuDropdownShowing = false;
				} });
			TweenMax.to(_setup.s.$menuDropdownsBg, 0.2, { autoAlpha: 0 });
			prevSectionName = null;
		}
	}, hoverOffDelay);
};

function lazyNavImgs($parent, name) {
	//setTriggeredOpen();
	if (!navImagesLoaded[name]) {
		$parent.find('[data-lazy-navimg]').each(function () {
			var $t = $(this);
			var $img = $('<img>');
			$img.on('load', function () {
				return $img.addClass('is-lazyloaded');
			}).attr({ src: $t.data('lazy-navimg') });
			$t.prepend($img);
		});
		navImagesLoaded[name] = true;
	}
};

//only allow click through after menu has opened
function linkClickHandlers(e, $link, name) {
	if (Modernizr.touchevents && name !== prevSectionName || isOpening) {
		e.preventDefault();
	}
};

function parentLinksHoverHandler(index, item) {
	var $this = $(item);
	var name = $this.find('.nx-header--navtext').text().toLowerCase();
	var $menuSection = $($this.data('dropdownmenu'));
	$this.mouseenter(function () {
		return lazyNavImgs($menuSection, name);
	}).hoverIntent(function () {
		return hoverOn($menuSection, name);
	}, $.noop).click(function (e) {
		return linkClickHandlers(e, $this, name);
	});
};

//bind it all up
_setup.s.$doc.ready(function () {
	if (_setup.s.$menuParentLinks) {

		$navOuter.on({
			'mouseenter': setTriggeredOpen,
			'mouseleave': closeMenuOverlay
		});

		_setup.s.$menuDropdowns.on({
			'mouseenter': setTriggeredOpen,
			'mouseleave': closeMenuOverlay
		});

		_setup.s.$menuParentLinks.each(parentLinksHoverHandler);

		_setup.s.$window.resize(function () {
			if (_setup._s.menuDropdownShowing) {
				closeMenuOverlay();
			}
		});
	}
});


//////////////////
// WEBPACK FOOTER
// ./_js/menu-dropdowns.js
// module id = 11
// module chunks = 0